export default [
  {
    koNm: '김효일',
    engNm: ' KIM HYOIL',
    position: '수석코치',
    birthday: '1978년 09월 07일',
    education: '경상대학교',
    img: 'coach_01'
  }, {
    koNm: '이광희',
    engNm: ' Lee Kwanghee',
    position: '코치',
    birthday: '1986년 07월 23일',
    education: '선문대학교',
    img: 'coach_02'
  }, {
    koNm: '이종호',
    engNm: ' Lee Jongho',
    position: '코치',
    birthday: '1992년 02월 24일',
    education: '광양제철고',
    img: 'coach_03'
  }, {
    koNm: '신화용',
    engNm: 'Shin Hwayong',
    position: 'GK코치',
    birthday: '1983년 04월 13일',
    education: '청주대학교',
    img: 'coach_04'
  }, {
    koNm: '김성준',
    engNm: 'Kim Sungjoon ',
    position: '피지컬코치',
    birthday: '1998년 07월 03일',
    education: 'Liverpool John\nMoores 석사',
    img: 'coach_05'
  }, {
    koNm: '김서기',
    engNm: 'Kim Seoki',
    position: '분석코치',
    birthday: '1993년 08월 27일',
    education: '호남대학교',
    img: 'coach_06'
  }
];
